<template>
  <v-card class="card-products-items">
    <div class="products-items pointer">
      <div
        class="product-image_item_store"
        @click="
          $router.push(
            `/productDetails/${item.name.replaceAll(' ', '-')}-${item.id}`
          )
        "
      >
        <img
          :src="item.pictureUrl ? item.pictureUrl : '/no-image.png'"
          alt=""
        />
      </div>
      <!-- Product details -->
      <div class="d-flex flex-column justify-space-between mt-1 p-2 h-100">
        <div>
          <h6
            @click="
              $router.push(
                `/productDetails/${item.name.replaceAll(' ', '-')}-${item.id}`
              )
            "
            class="mainFont--text text-right font-weight-bold fs-xsmall"
          >
            {{ item.name ? item.name : "نام محصول " }}
          </h6>
        </div>

        <div
          class="d-flex justify-content-end"
          v-if="item.specialPrice == item.price || item.sum === 0"
        >
          <v-col v-if="item.sum === 0" class="mr-0 pr-0 align-start text-right">
            <div class="error--text">
              <v-icon small color="error">mdi-close-circle</v-icon>
              ناموجود
            </div>
          </v-col>
          <v-col>
            <div
              @click="
                $router.push(
                  `/productDetails/${item.name.replaceAll(' ', '-')}-${item.id}`
                )
              "
              v-if="item.specialPrice == item.price"
            >
              <p
                class="shoppurple--text text-left fs-small mb-0 font-weight-bold"
              >
                {{ Number(item.price).toLocaleString() }} تومان
              </p>
            </div>
          </v-col>
        </div>

        <div
          @click="
            $router.push(
              `/productDetails/${item.name.replaceAll(' ', '-')}-${item.id}`
            )
          "
          v-else
        >
          <div class="d-flex justify-content-end">
            <div
              class="d-flex justify-center align-center text-center"
              style="
                border-radius: 10%;
                background-color: #ef5350 !important ;
                width: 30px;
                height: 30px;
                font-size: 10px;
                margin-left: 12px;
              "
            >
              <span class="white--text text-center fs-small"
                >{{ item.discountPercentage }}%</span
              >
            </div>
            <del class="red--text text-left fs-small mb-0">
              {{ Number(item.price).toLocaleString() }} تومان
            </del>
          </div>
          <p
            class="shoppurple--text text-left fs-small mb-0 font-weight-bold mb-0"
          >
            {{ Number(item.specialPrice).toLocaleString() }}
            تومان
          </p>
        </div>
        <div v-if="!cartId">
          <v-btn
            :disabled="item.sum === 0"
            block
            @click="
              $router.push(
                `/productDetails/${item.name.replaceAll(' ', '-')}-${item.id}`
              )
            "
            class="purple-mainBtn mt-2 add-product fs-xxsmall"
          >
            مشاهده محصول
          </v-btn>
        </div>
        <div v-else>
          <div v-if="loading" class="loading-btn text-center py-1 w-100">
            <half-circle-spinner
              :animation-duration="1000"
              :size="20"
              color="#6200ea"
              class="mx-auto"
              style="margin-top: 2px"
            />
          </div>
          <div
            v-else-if="
              cart.filter((x) => x.id == item.id).length === 0 ||
              cart.filter((x) => x.id == item.id)[0].amount === 0
            "
          >
            <v-btn
              :disabled="item.sum === 0"
              block
              @click="addToCart(item)"
              class="purple-mainBtn mt-2 add-product fs-xxsmall"
            >
              افزودن به سبد خرید
            </v-btn>
            <!--          <v-btn v-else variant="flat" block color="error">-->
            <!--            <v-icon size="20" color="white" class="me-1"-->
            <!--            >mdi-close-circle-->
            <!--            </v-icon>-->
            <!--            <span class="font-weight-bold">ناموجود</span>-->
            <!--          </v-btn>-->
          </div>

          <div v-else>
            <div class="d-flex justify-center text-center align-center">
              <product-counter
                class="operations text-center mt-2 w-100"
                :item="cart.filter((x) => x.id == item.id)[0]"
                :index="cart.findIndex((x) => x.id == item.id)"
                :usage="'store'"
                :cart-id="cartId"
                @send-amount="handleAmount"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import ProductCounter from "../../../../components/OnlineShop/ProductCounter";
import Axios from "axios";
import { mapState } from "vuex";

export default {
  name: "StoreItem",
  components: { ProductCounter, HalfCircleSpinner },
  props: ["item", "cartId"],
  data() {
    return {
      currentPage: 1,
      pageLoading: true,
      availability: false,
      filters: {},
      allItems: [],
      latestQuery: "",
      totalPages: 0,
      available: false,
      filtersList: {},
      loading: false,
      selectedQuery: [],
      selectedFilter: [],
      selectedQueryPage: "",
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.onlineShop.cart,
      isLoading: (state) => state.onlineShop.isLoading,
      productIndexInCart: (state) => state.onlineShop.productIndexInCart,
    }),
    computedItemsCount() {
      if (this.availability) {
        return this.allItems.filter((x) => x.sum != 0).length;
      } else {
        return this.allItems.length;
      }
    },
    computedItems() {
      let myItems = this.allItems;
      if (this.availability) {
        myItems = myItems.filter((x) => x.sum != 0);
      }
      return myItems;
    },
  },
  methods: {
    handleAmount(event) {
      this.item.amountInCart = event;
    },
    next() {
      let query = this.selectedQuery;

      if (query.length == 0) {
        this.getAll(this.currentPage);
      } else {
        this.getFilterProduct(this.selectedQuery, this.currentPage);
      }
    },
    getAll(selectedPage) {
      this.latestQuery = "all";
      this.pageLoading = true;
      Axios.get(this.baseUrl + `/onlineShop/items/list?page=${selectedPage}`, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.allItems = res.data.items;
          this.totalPages = res.data.totalPages;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.toast.error("خطا: " + err.response.data);

          this.pageLoading = false;
        });
    },

    getFilterProduct(query, selectedPage) {
      let latestQuery = query;
      let q = "";

      latestQuery.forEach((filter, index) => {
        if (filter.key != "all" && filter.selectedFilter != "") {
          q += filter.key + "=" + filter.selectedFilter;
          if (index < latestQuery.length - 1) q += "&";
        } else {
          q += filter.key;
        }
      });

      this.pageLoading = true;
      Axios.get(
        this.baseUrl + `/onlineShop/items/search?${q}&page=${selectedPage}`,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.allItems = res.data.items;
          this.totalPages = res.data.totalPages;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.toast.error("خطا: " + err.response.data);
        });
    },

    addToCart(item) {
      if (localStorage.getItem("shopToken")) {
        this.loading = true;
        Axios.post(
          this.baseUrl + "/onlineShop/cart/addItem/" + this.cartId,
          {
            amount: 1,
            warehouseItemId: item.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("shopToken"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast(res.data.message, "success");
              item.amountInCart++;
              this.$store
                .dispatch("getCartData", {
                  cartId: this.cartId,
                })
                .finally(() => {
                  this.loading = false;
                });
            } else {
              this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            this.toast.error(err.response.data);
            this.loading = false;
          });
      } else {
        this.toast("ابتدا وارد شوید", "error");
      }
    },

    removeItem(item) {
      this.pageLoading = true;

      Axios.post(
        this.baseUrl + "/onlineShop/cart/removeItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast.success(res.data.message);
            item.amountInCart--;

            this.pageLoading = false;
          } else {
            this.toast.error("خطایی رخ داده است. مجددا امتحان کنید.");
            this.pageLoading = false;
          }
        })
        .catch((err) => {
          this.toast.error(err.response.data);
          this.pageLoading = false;
        });
    },

    setAvailableProducts() {
      // this.emitter.emit("availability", this.available);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-products-items {
  width: 100%;
  height: 560px;
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
}
.products-items {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  @media (max-width: 375px) {
    justify-content: center;
  }

  .product-image_item_store {
    height: 370px;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
      border-radius: 12px 12px 0 0;
      aspect-ratio: 1 / 2;
    }
  }
}
.add-product {
  height: 33px !important;
}

.loading-btn {
  background-color: #fff;
  border: 1px solid #6200ea;
  border-radius: 8px;
  height: 35px;
  padding: 0 5px;
  width: 110px;
  display: flex;
  justify-content: center;
  align-self: center;

  .count {
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 5px 15px;
  }
}
</style>
